import * as _ from 'lodash';

export class FileResult {
    /**
     * @param {File} file
     * @param {string} data
     */
    constructor(file, data) {
        this.name = file.name;
        this.size = file.size;
        this.type = file.type;
        this.data = data;
    }

    /**
     * @param {File} file
     * @return {Promise<FileResult>}
     */
    static load(file) {
        return new Promise((resolve, reject) => {
            var reader = new FileReader();
            reader.addEventListener("load", () => {
                resolve(new FileResult(file, reader.result));
            }, false);
            reader.addEventListener("abort", () => {
                reject('Aborted');
            }, false);
            reader.addEventListener("error", () => {
                reject('Error');
            }, false);

            reader.readAsDataURL(file);

            return file.name;
        });
    }
}

function allSettled(promises) {
    return Promise.all(promises.map(x => Promise.resolve(x).then(
        val => ({ status: 'fulfilled', value: val }),
        reason => ({ status: 'rejected', reason: reason })
    )));
}

angular.module("tromanWeb").directive("ergoFileInput", [function () {
    return {
        restrict: 'A',
        scope: {
            fileAdded: '&ergoFileInput',
        },
        link: function (scope, element, _attributes, _controller) {
            if (!scope.fileAdded) return;

            element.on('input', function (_event) {
                allSettled(_.map(element[0].files, FileResult.load)).then(result => {
                    let files = [];

                    for (let res of result) {
                        if (res.status === 'fulfilled') {
                            files.push(res.value);
                        } else {
                            console.log('Failed to load file', res.reason);
                        }
                    }

                    element[0].value = null;

                    scope.$applyAsync(() => {
                        scope.fileAdded({
                            $files: files,
                        });
                    });
                });
            });
        }
    };
}]);
